export default __webpack_public_path__ + "static/logo-e4a23ffd462563a2a6ddfd6c35633d63.png";